<template>
  <button
    class="modal-close-button"
    type="button"
    @click="$emit('click')"
  >
    <CancelIcon fill-color="var(--80)" />
  </button>
</template>

<script>
  import CancelIcon from '@/_legacy/components/Icons/CancelIcon.vue';

  export default {
    components: {
      CancelIcon,
    },
  };
</script>
